import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { AppLayoutComponent, AuthGuard, LoginComponent, NotfoundComponent } from 'shared';






@NgModule({
  imports: [
    RouterModule.forRoot(
      [
        {
          path: '',
          component: AppLayoutComponent,
          children: [
            {
              path: '',
              data: { breadcrumb: 'Πίνακας Ελέγχου' },
              loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent),
              canActivate:[AuthGuard]
            },
            {
              path: 'insurance-management',
              data: { breadcrumb: 'Διαχείριση Παροχών' },
              loadComponent: () => import('./pages/insurance-management/insurance-management.component').then(m => m.InsuranceManagementComponent),
              canActivate:[AuthGuard]
            },
            {
              path: 'client-management',
              data: { breadcrumb: 'Διαχείριση Πελατών' },
              loadComponent: () => import('./pages/client-management/client-management.component').then(m => m.ClientManagementComponent),
              canActivate:[AuthGuard]
            },
            {
              path: 'agency-management',
              data: { breadcrumb: 'Διαχείριση Αποζημιώσεων' },
              loadComponent: () => import('./pages/agency-management/agency-management.component').then(m => m.AgencyManagementComponent),
              canActivate:[AuthGuard]
            },
            {
              path: 'claim-details/:auditorClaimId',
              data: { breadcrumb: '' },
              loadComponent: () => import('./pages/claim-details/claim-details.component').then(m => m.ClaimDetailsComponent),
              canActivate:[AuthGuard]
            },
          ],
        },
        { path: 'login', component: LoginComponent },
        // { path: 'register', component: RegisterComponent },
        { path: 'notfound', component: NotfoundComponent },
        { path: '**', redirectTo: '/notfound' },
      ],
      {
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
        onSameUrlNavigation: 'reload',
      }
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
